import styled from 'styled-components';

export const OverviewPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const OverviewHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const OverviewCards = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;

  & > div {
    flex: 1 1 300px;
  }
`;

export const OverviewDougnutContainer = styled.div`
  width: 20rem;
  
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;
